import { Mail, Phone } from "lucide-react";

// Two-position slider: the pill glides between Email and Phone.
export const ContactMethodSlider = ({ value, onChange }) => {
  const phone = value === "phone";
  return (
    <div className="flex items-center justify-end gap-3" data-testid="contact-toggle">
      <span className={`text-[11px] font-bold uppercase tracking-widest transition-colors duration-200 ${phone ? "text-muted-foreground" : "text-white"}`}>
        Email
      </span>
      <button type="button" role="switch" aria-checked={phone} aria-label="Contact method"
        onClick={() => onChange(phone ? "email" : "phone")} data-testid="contact-method-slider"
        className="relative w-[124px] h-9 border border-border bg-background rounded-full p-1 transition-colors duration-200 hover:border-[#007AFF]/60">
        <span aria-hidden className={`absolute top-1 left-1 h-7 w-[58px] rounded-full bg-[#007AFF] transition-transform duration-300 ease-out ${phone ? "translate-x-[58px]" : "translate-x-0"}`} />
        <span className="relative z-10 grid grid-cols-2 h-full">
          <span className={`flex items-center justify-center gap-1 text-[10px] font-bold uppercase tracking-wider transition-colors duration-200 ${phone ? "text-muted-foreground" : "text-white"}`}>
            <Mail className="w-3 h-3" /> Email
          </span>
          <span className={`flex items-center justify-center gap-1 text-[10px] font-bold uppercase tracking-wider transition-colors duration-200 ${phone ? "text-white" : "text-muted-foreground"}`}>
            <Phone className="w-3 h-3" /> Phone
          </span>
        </span>
      </button>
      <span className={`text-[11px] font-bold uppercase tracking-widest transition-colors duration-200 ${phone ? "text-white" : "text-muted-foreground"}`}>
        Phone
      </span>
    </div>
  );
};
